// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/ActionsAction/Content/Content/CopyAction/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Procedures_ActionsAction_Content_Content_CopyAction($objects: [vaxiom_procedures_insert_input!]!) {
  insert_vaxiom_procedures(objects: $objects) {
    affected_rows
  }
}

`